import styled from 'styled-components';

const SiteHeaderLogoLink = styled.a`
   line-height: ${({ theme }) => theme.sizes.siteHeaderHeight};
   display: inline-block;
`;

export { SiteHeaderLogoLink };
